import { observable, action } from 'mobx'

export default class {
  form
  constructor(form) {
    this.form = form
  }
  @observable
  doubleInputValue = {
    key: '',
    value: [{ id: '0', title: '', extra: '', unit: '' }]
  }
  @action
  init = (key, value) => {
    this.doubleInputValue.key = key
    this.doubleInputValue.value = value || [
      { id: '0', title: '', extra: '', unit: '' }
    ]
  }
  @action
  handleChangeKey = (title, index) => {
    this.doubleInputValue.value[index].title = title
  }
  @action
  handleChangeValue = (extra, index) => {
    this.doubleInputValue.value[index].extra = extra
    // todo
    this.doubleInputValue.value[index].unit = extra + '个'
  }
  @action
  addInput = () => {
    this.doubleInputValue.value = [
      ...this.doubleInputValue.value,
      { id: '0', title: '', extra: '', unit: '' }
    ]
  }
  @action
  deleteLastValue = () => {
    if (this.doubleInputValue.value.length > 1) {
      this.doubleInputValue.value = this.doubleInputValue.value.slice(0, -1)
      const deleteIndex = this.doubleInputValue.value.length
      const key = this.doubleInputValue.key
      this.form.setFieldsValue({
        [`${key}-${deleteIndex}-title`]: '',
        [`${key}-${deleteIndex}-extra`]: ''
      })
    }
  }
}
